import Accordions4i from '../../common/accordions25.js';
import WhyWorkVideo from './modules/video.js';

const accordions = new Accordions4i();

async function init(){
    const mainContent = document.querySelector("#mainContent");
    accordions.init(mainContent);

    WhyWorkVideo.init();
    document.addEventListener("click", events);
}

async function events(e){
    if(e.target.classList.contains("storyDialogBtn")){
        e.preventDefault();
        const storyDialog = await loadStoryDialog();
        if(!storyDialog) return; // If dialog failed to load, exit early
        storyDialog.open(e, e.target);
    }
}

let storyDialogPromise = null;
async function loadStoryDialog() {
    if(storyDialogPromise){ return storyDialogPromise.default; }
    try {
        storyDialogPromise = await import('./dialogs/stories.js');
        storyDialogPromise.default.init();
        return storyDialogPromise.default; // Return the default export
    } catch (error) {
        console.error("Error in loadStoryDialog. Failed to load story dialog module:", error);
        storyDialogPromise = null; // Reset to allow retry on failure
        return null;
    }
}

await init();